"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardDataWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardDataWrapper = require("./PropertyCardDataWrapper.styles");
/**
 * A container for the property data and action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
var PropertyCardDataWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardDataWrapper.StyledPropertyCardDataWrapper, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardDataWrapper = PropertyCardDataWrapper;
PropertyCardDataWrapper.displayName = 'PropertyCard.DataWrapper';